import React, { Component, useContext, useEffect, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, formatDate, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
// import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select';
import ToggleSwitch from '../../Components/ToggleSwitch';
import { NoRecords } from '../../Components/Shimmer';
import { currentDateAndTime } from '../../Constants/Constants';

const ModuleMaster = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON } = useContext(ConfigContext);
    const [rows, setRows] = useState([]);
    const [parentHeaderRows, setParentHeaderRows] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [loadingPost, setLoadingPost] = useState(false);
    const [formData, setFormData] = useState({
        companyId: "",
        headerName: "",
        headerPath: "",
        headerIcon: "",
        headerStatus: "0",
        parentId: null,
    });
    const [errors, setErrors] = useState({});

    const getList = () => {
        const headers = apiHeaderJSON || { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, 'x-company-id': localStorage.getItem("company_id_master"), 'x-user-id': localStorage.getItem("user_id_master") };
        axios.get(`${apiURL}CompanyMasters/GetHeaderList`, {
            params: {
                // companyId: formData?.companyId
            }, headers
        }).then((response) => {
            let data = response.data;
            console.log(data);
            if (response.data.success === true) {
                let rows = data?.header_list?.map((val) => {
                    return { value: val?.module_id, label: val?.header_name }
                });
                setParentHeaderRows(rows);
                setRows(data?.header_list);
            } else {
                setParentHeaderRows([]);
                setRows([]);
                console.error("Error fetching list");
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }

    const getCompanies = () => {
        const headers = apiHeaderJSON || { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, 'x-company-id': localStorage.getItem("company_id_master"), 'x-user-id': localStorage.getItem("user_id_master") };
        axios.get(`${apiURL}CompanyMasters/getCompanies`, {
            params: {
            }, headers
        }).then((response) => {
            let data = response.data;
            console.log(data);
            if (response.data.success === true) {
                let rows = data?.companies?.map((val) => {
                    return { value: val?.company_id, label: val?.company_name }
                });
                setCompanyOptions(rows);
            } else {
                console.error("Error fetching list");
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }

    useEffect(() => {
        if (isChanged) {
            getList();
            setIsChanged(false);
        }
    }, [isChanged]);

    useEffect(() => {
        getList();
    }, []);

    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    }

    const handleToggleSwitch = () => {
        setFormData((prevData) => ({
            ...prevData,
            headerStatus: formData?.headerStatus == "1" ? "0" : "1",
        }));
    };

    const getInfo = (row) => {
            setFormData({
                ...formData,
                module_id: row?.module_id,
                headerName: row?.header_name,
                headerPath: row?.header_path,
                headerIcon: row?.header_icon || "",
                parentId: row?.parent_id,
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        // const errors = validateForm();
        // console.log("errors 1", errors);
        // if (Object.keys(errors).length > 0) {
        //     setErrors(errors);
        //     return;
        // }
        setLoadingPost(true);
        let data = {
            moduleId: formData?.module_id || null,
            headerName: formData?.headerName,
            headerPath: formData?.headerPath,
            headerIcon: formData?.headerIcon || "",
            parentId: formData?.parentId,
            date: currentDateAndTime(),

        }

        const headers = apiHeaderJSON || { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, 'x-company-id': localStorage.getItem("company_id_master"), 'x-user-id': localStorage.getItem("user_id_master") };
        // console.log("formData?.companyId", formData?.companyId);
        // console.log("handleSubmit ~ form Data =======>>>", formData);
        axios
            .post(`${apiURL}CompanyMasters/CreateHeader`, data, {
                params: {
                    user_id: localStorage?.getItem("user_id_master"),
                    // companyId: formData?.companyId
                },
                headers,
            })
            .then((response) => {
                const { success, } = response.data;
                console.log("handleSubmit ~ response =======>>>", response);
                if (success === true) {

                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true,  // Show OK button
                    });
                    setFormData({
                        companyId: formData?.companyId,
                        headerName: "",
                        headerPath: "",
                        headerStatus: "0",
                        headerIcon: "",
                        parentId: "",
                    });
                    getList();
                    setLoadingPost(false);
                } else {
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true,  // Show OK button
                    });
                    setLoadingPost(false);

                }
            });

    }
    const handleClearAll=()=>{
        setFormData({
            companyId: formData?.companyId,
            headerName: "",
            headerPath: "",
            headerStatus: "0",
            headerIcon: "",
            parentId: "",
        });
    }

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Module Master`} primary={`Home`} />
                    <div className="row card">
                        {/* <div className=' col-md-12'>
                            <div className="  col-md-5 mt-3 mb-3">
                                <label>Select Company</label>
                                <Select
                                    onChange={(selectedOption) => { setIsChanged(true); setFormData({ ...formData, companyId: selectedOption?.value })}}
                                    placeholder={`Select Company`}
                                    options={companyOptions}
                                    value={formData?.companyId ? companyOptions.find(option => option.value === formData?.companyId) : null}
                                />
                                {errors.companyId && <div className="text-danger">{errors.companyId}</div>}
                            </div>
                        </div> */}
                        <div className=' row card-body'>

                            <div className="col-md-5">
                                <div style={{"height": "65vh"}} className="card">
                                    {/* <div className=' col-md-12'>
                                        <div className=" mx-3 mt-2 mb-1">
                                            <label>Select Company</label>
                                            <Select
                                                onChange={(selectedOption) => { setIsChanged(true); setFormData({ ...formData, companyId: selectedOption?.value }) }}
                                                placeholder={`Select Company`}
                                                options={companyOptions}
                                                value={formData?.companyId ? companyOptions.find(option => option.value == formData?.companyId) : null}
                                            />
                                            {errors.companyId && <div className="text-danger">{errors.companyId}</div>}
                                        </div>
                                    </div> */}
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">{formData?.module_id ? "Update" : "Create"} Navigation Header</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form onSubmit={handleSubmit} className="row">
                                                    {/* <div className=' col-md-12'>
                                                        <div className="col-md-12 mt-3 mb-3">
                                                            <label>Select Company</label>
                                                            <Select
                                                                onChange={(selectedOption) => setFormData({ ...formData, companyId: selectedOption?.value })}
                                                                placeholder={`Select Company`}
                                                                options={companyOptions}
                                                                value={formData?.companyId ? companyOptions.find(option => option.value === formData?.companyId) : null}
                                                            />
                                                            {errors.companyId && <div className="text-danger">{errors.companyId}</div>}
                                                        </div>
                                                    </div> */}
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="headerName" className="form-label">Header Name</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.headerName ? 'is-invalid' : ''}`}
                                                            id="headerName"
                                                            name="headerName"
                                                            value={formData?.headerName}
                                                            onChange={(e) => handleChange("headerName", e.target.value)}
                                                            placeholder="Enter Header Name"
                                                        />
                                                        {errors.headerName && <div className="text-danger">{errors.headerName}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="headerPath" className="form-label">Header Path</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.headerPath ? 'is-invalid' : ''}`}
                                                            id="headerPath"
                                                            name="headerPath"
                                                            value={formData?.headerPath}
                                                            onChange={(e) => handleChange("headerPath", e.target.value)}
                                                            placeholder="Enter Header Name"
                                                        />
                                                        {errors.headerPath && <div className="text-danger">{errors.headerPath}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <label>Select Parent Header</label>
                                                        <Select
                                                            onChange={(selectedOption) => setFormData({ ...formData, parentId: selectedOption?.value })}
                                                            placeholder={`Select Parent`}
                                                            options={parentHeaderRows}
                                                            value={formData?.parentId ? parentHeaderRows.find(option => option.value == formData?.parentId) : null}
                                                        />
                                                        {errors.parentId && <div className="text-danger">{errors.parentId}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <label htmlFor="headerIcon" className="form-label">Header Icon</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.headerIcon ? 'is-invalid' : ''}`}
                                                            id="headerIcon"
                                                            name="headerIcon"
                                                            value={formData?.headerIcon}
                                                            onChange={(e) => handleChange("headerIcon", e.target.value)}
                                                            placeholder="Icon Class"
                                                        />
                                                        {errors.headerIcon && <div className="text-danger">{errors.headerIcon}</div>}
                                                    </div>
                                                    {/* <div className="col-md-6 mt-3">
                                                        <div>
                                                            <label>Do you want to show this header?</label>
                                                        </div>
                                                        <div className="">
                                                            <div className=' d-flex align-items-center gap-2'>
                                                                <ToggleSwitch isActive={formData?.headerStatus == '1'} isExtFunc={true} onToggle={handleToggleSwitch} />
                                                                <span style={{ fontSize:"1.1rem", fontWeight:"600"}} className=' pb-2'>{formData?.lockAttendanceAndLeave === 1 || formData?.lockAttendanceAndLeave === "1"? "On":"Off"}</span> 
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    <div className="col-md-12 mt-3 mb-3 d-flex justify-content-between align-items-center" >
                                                        <SubmitButton disabled={!formData?.headerName} loading={loadingPost}
                                                        buttonName={formData?.module_id ? "Update" : "Save"} loadingMessage='Loading' type='primary' icon='ri-save-line' />
                                                        {formData?.module_id && (
                                                            <SubmitButton disabled={loadingPost} onClick={handleClearAll}
                                                            buttonName="Cancel" type='secondary' icon='ri-close-line' />
                                                        )}
                                                        
                                                    </div>

                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className='card'>
                                    <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="  col-md-12">
                                        <table className={`position-relative table table-bordered table-stripped `}>
                                            <thead className='table-light sticky-top z-1'>
                                                <tr>

                                                    <th>Header Name</th>
                                                    <th>Header Path</th>
                                                    <th>Parent Name</th>
                                                    {/* <th>Status</th> */}
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            {rows?.length === 0 ?
                                                <tbody>
                                                    <tr>
                                                        <td colSpan={5}>
                                                            <NoRecords />
                                                        </td>
                                                    </tr>
                                                </tbody> :
                                                <tbody>
                                                    {
                                                        rows?.map((row) => {
                                                            return <tr key={row.module_id}>
                                                                <td>{row.header_name}</td>
                                                                <td>{row.header_path || ""}</td>
                                                                <td className={`${!row.parent_header_name? " text-center":""}`}>{row.parent_header_name || "--"}</td>
                                                                {/* <td className=' text-center'> */}
                                                                    {/* {row?.header_status == '1' ? <span style={{ borderRadius:"5px", fontWeight:"700"}} className=' py-1 px-2 bg-success text-white'>On</span>:<span style={{ borderRadius:"5px", fontWeight:"700"}} className=' py-1 px-2 bg-warning text-white'>Off</span> } */}
                                                                    {/* <ToggleSwitch isActive={row?.header_status == '1'} isExtFunc={true} onToggle={() => { }} /> */}
                                                                {/* </td> */}
                                                                <td className='d-flex justify-content-around'>
                                                                    <button type='button' onClick={() => {  getInfo(row) }} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>
                                                                    {/* <button onClick={() => this.handleDelete(row.leave_type_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button> */}
                                                                    {/* <button type='button' onClick={() => this.setState({ leave_type_id: row.leave_type_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-info" data-bs-toggle="modal" data-bs-target="#myModal"> <i className="mdi mdi-view-list-outline fs-4"></i> </button> */}
                                                                </td>
                                                            </tr>
                                                        })
                                                    }
                                                </tbody>
                                            }

                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default ModuleMaster;
